import { useTranslation } from "react-i18next";

export default function ProjectReportUd1000PdfCoverIntroPage({
  projectName,
  periodEndYearMonth,
  headline,
  contractor,
  logoSrc = "/images/mainLogo.png",
}) {
  const { t } = useTranslation();

  return (
    <div
      className="projectReportUd1000CoverPage is-intro"
      data-report-cover="true"
      data-report-page-number-hidden="true"
    >
      <div className="projectReportUd1000CoverShell">
        <div className="projectReportUd1000CoverProjectName">{projectName}</div>
        <div className="projectReportUd1000CoverHeadline">
          {headline ||
            t("projectDetail.projectReportEditor.ud1000Cover.introHeadline", {
              defaultValue: "\uC735\uD569 \uC548\uC804\uC810\uAC80 \uACB0\uACFC\uBCF4\uACE0\uC11C",
            })}
        </div>
        <div className="projectReportUd1000CoverDateChip">
          {periodEndYearMonth}
        </div>
        <img
          className="projectReportUd1000CoverIntroLogo"
          src={logoSrc}
          alt={t("projectDetail.projectReportEditor.ud1000Cover.logoAlt", {
            defaultValue: "Check Guard 로고",
          })}
        />
        <div className="projectReportUd1000CoverFooterValue">{contractor}</div>
      </div>
    </div>
  );
}
